import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../Header/Header';
import LeftSide from '../../Header/LeftSide/LeftSide';
import { collection, getDocs } from 'firebase/firestore';
import { firestore } from './firebase';
import './DeleteService.css'

const UpdateService = () => {
    const navigate = useNavigate();
    const [services, setServices] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [filteredServices, setFilteredServices] = useState([]);

    useEffect(() => {
        const mySession = localStorage.getItem("sesion_true_KLKas4874asasdkljs565dKJKLJ3asdkljas_asdlsad_+=(loremedia.ma)");
        if (mySession !== 'true') {
            navigate("/anaadmin");
        }
    }, [navigate]);

    useEffect(() => {
        async function fetchServices() {
            try {
                const querySnapshot = await getDocs(collection(firestore, 'portfolioServices'));
                const servicesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setServices(servicesData);
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        }

        fetchServices();
    }, []);

    useEffect(() => {
        if (selectedCategory) {
            const filtered = services.filter(service => service.imgTag === selectedCategory);
            setFilteredServices(filtered);
        } else {
            setFilteredServices(services);
        }
    }, [selectedCategory, services]);


    return (
        <div className='Dashboard'>
            <Header />
            <LeftSide />
            <div className='HomeDashboard p-2'>
                <div className="myFilterDashService flex justify-center mt-8">
                    <nav className="flex space-x-4 border">
                        <button
                            className={`filter-btn ${selectedCategory === null ? 'active' : ''}`}
                            onClick={() => setSelectedCategory(null)}
                        >
                            All
                        </button>
                        <button
                            className={`filter-btn ${selectedCategory === 'design' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('design')}
                        >
                            Design
                        </button>
                        <button
                            className={`filter-btn ${selectedCategory === 'developement' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('developement')}
                        >
                            Development
                        </button>
                        <button
                            className={`filter-btn ${selectedCategory === 'stands' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('stands')}
                        >
                            Stands
                        </button>
                        <button
                            className={`filter-btn ${selectedCategory === 'signaletique' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('signaletique')}
                        >
                            Signalétique
                        </button>
                        <button
                            className={`filter-btn ${selectedCategory === 'renovation' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('renovation')}
                        >
                            Renovation
                        </button>
                    </nav>
                </div>

                <div className="ServicesSectionDash grid grid-cols-3 gap-4 mt-8">
                    {filteredServices.map(service => (
                        <div key={service.id} className="MyService p-3 shadow-black rounded-lg shadow">
                            <img src={service.imgSrc} alt={service.imgTag} className="h-40 w-full object-cover mb-2" />
                            <p className="text-lg font-semibold">{service.imgTag}</p>
                            <p className="text-sm">{service.imgDesc}</p>
                            <Link to={"/anaadmin/dashboard/upService/"+service.id}><button className="btn btnDelete bg-blue-600 text-white p-1 px-2 rounded-lg mt-2">Update</button></Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UpdateService;
